import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { plugin as formkitPlugin } from "@formkit/vue";
import formkitConfig from "./config/formkit.config.js";
import App from "./App.vue";
import router from "./router";
import "leaflet/dist/leaflet.css";
import "./assets/styles/main.css";

// Fix Leaflet default icon issue with Vite
import L from "leaflet";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl,
  iconRetinaUrl,
  shadowUrl
});

// Initialize Firebase (imports will trigger initialization)
import "./firebase";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(formkitPlugin, formkitConfig);

app.mount("#app");
